import React from 'react';

import { Typography } from '@material-ui/core';

const PoweredBy = () => (
  <div className="poweredby-wrap">
    <Typography component="p" className="poweredby">
      Powered by <a target="_blank" href="https://arryved.com?utm_source=beerquest" rel="noopener noreferrer">Arryved</a>
    </Typography>
  </div>
);

export default PoweredBy;
